import * as ACCOUNT_API from '@/api/account'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async getAccounts ({ commit }, data) {
      let response = await ACCOUNT_API.getAccounts(data)
      return response.data
    },
    async getAccount ({ commit }, id) {
      let response = await ACCOUNT_API.getAccount(id)
      return response.data
    },
    updateAccount({ commit }, { id, data }) {
      return ACCOUNT_API.updateAccount(id, data).then(resp => {
        return resp.data
      })
    },
    deleteAccount({ commit }, id) {
      return ACCOUNT_API.deleteAccount(id).then(resp => {
        return resp.data
      })
    },
    searchAccount({ commit }, query) {
      return ACCOUNT_API.searchAccount(query).then(resp => {
        return resp
      })
    },
    getCustomerProvidedByAccount({ commit }, accountId) {
      return ACCOUNT_API.getCustomerProvidedByAccount(accountId).then(resp => {
        return resp
      })
    },
    updateCustomerProvidedByAccount({ commit }, data) {
      return ACCOUNT_API.updateCustomerProvidedByAccount(data).then(resp => {
        return resp
      })
    },
    deleteCustomerProvidedByAccount({ commit }, accountId) {
      return ACCOUNT_API.deleteCustomerProvidedByAccount(accountId).then(resp => {
        return resp
      })
    },
    getAccountRecentActivitiesSummary({ commit }, accountId) {
      return ACCOUNT_API.getAccountRecentActivitiesSummary(accountId).then(resp => {
        return resp
      })
    }
  }
}
